import { AxiosPromise } from "axios";
import { axiosInstanceWithoutToken } from "../instance";
import { AuthLoginRequest, AuthLoginResponse } from "./types";

export const login = (params: AuthLoginRequest): AxiosPromise<AuthLoginResponse> =>
  axiosInstanceWithoutToken.post(`/auth/login`, params);
